import { useEffect, useState, useRef } from "react";
import axios from 'axios';
import { Link, useSearchParams } from "react-router-dom";
import AlertMessage from "../include/AlertMessage";
import { Html5QrcodeScanner } from "html5-qrcode";
import { getPagination } from "../include/pagination";
var _ = require('lodash');

function Bookings() {
  const [searchId, setSearchId] = useState("");
  const [result, setResult] = useState(null);
  const [tableName, setTableName] = useState("");
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ type: "", message: "" });
  const [errors, setErrors] = useState({});
  const [paymentStatus, setPaymentStatus] = useState("");
  const [hasCome, setHasCome] = useState("");
  const token = sessionStorage.getItem('JWT_TOKEN');

  const [eventBookings, setEventBookings] = useState([]);
  const [courseBookings, setCourseBookings] = useState([]);

  const [allUsers, setallUsers] = useState([]);
  const [allCourses, setAllCourses] = useState([]);
  const [allEvents, setAllEvents] = useState([]);

  const [showScanner, setShowScanner] = useState(false);
  const scannerRef = useRef(null);

  const [currentEventPage, setCurrentEventPage] = useState(1);
  const [totalEventPages, setTotalEventPages] = useState(1);
  const [totalEventRecord, setTotalEventRecord] = useState(0);


  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecord, setTotalRecord] = useState(0);

  //const [limit, setLimit] = useState(10);
  const limit = 10;


  const fetchAllUsers = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/customers`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token // Replace with your token
        }
      });
      const userdata = await response.data;
      if (Array.isArray(userdata.data) && userdata.data.length > 0) {
        setallUsers(userdata.data);
      } else {
        setallUsers([]);
      }
    } catch (err) {
      const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Something went wrong");
      setAlert({ type: "error", message: apierror });
    } finally {
      setLoading(false);
    }

  };

  const fetchAllCourses = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/courses`, {
        params: {
          latitude: 0,
          longitude: 0,
          radius: 0
        },
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token // Replace with your token
        }
      });
      const eventdata = await response.data;
      if (Array.isArray(eventdata.data) && eventdata.data.length > 0) {
        setAllCourses(eventdata.data);
      } else {
        setAllCourses([]);
      }
    } catch (err) {
      const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Something went wrong");
      setAlert({ type: "error", message: apierror });
    } finally {
      setLoading(false);
    }
  };

  const fetchAllEvents = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/events`, {
        params: {
          latitude: 0,
          longitude: 0,
          radius: 0
        },
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token // Replace with your token
        }
      });
      const eventdata = await response.data;
      if (Array.isArray(eventdata.data) && eventdata.data.length > 0) {
        setAllEvents(eventdata.data);
      } else {
        setAllEvents([]);
      }
    } catch (err) {
      const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Something went wrong");
      setAlert({ type: "error", message: apierror });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    document.documentElement.className = "";

    //get all booking who has visted and hasCome to true
    //getAllbookingWhoHasVisited();
    fetchAllUsers();
    fetchAllCourses();
    fetchAllEvents();
  }, []);

  useEffect(() => {
    getAllbookingWhoHasVisited();
  }, [currentEventPage, currentPage]);

  useEffect(() => {
    if (showScanner) {

      const scanner = new Html5QrcodeScanner(
        "reader",
        {
          fps: 10,
          qrbox: { width: 250, height: 250 },
        },
        false
      );

      scanner.render(
        async (decodedText) => {
          setSearchId(decodedText);

          await scanner.clear();

          scannerRef.current = null;
          setShowScanner(false);

          // Auto search
          searchBooking(decodedText);
        },
        (error) => {
          console.error(error);
        }
      );

      scannerRef.current = scanner;
    }

    return () => {
      if (scannerRef.current) {
        scannerRef.current.clear().catch(() => { });
        scannerRef.current = null;
      }
    };
  }, [showScanner]);

  // ✅ Validation
  const validate = () => {
    const newErrors = {};
    if (!searchId) newErrors.ticket_id = "Ticket ID is required.";
    return newErrors;
  };

  const startScanner = () => {
    setShowScanner(true);

    setTimeout(() => {
      if (!scannerRef.current) {
        scannerRef.current = new Html5QrcodeScanner(
          "reader",
          {
            fps: 10,
            qrbox: { width: 250, height: 250 },
          },
          false
        );

        scannerRef.current.render(
          async (decodedText) => {
            // QR se jo value aaye usko Ticket ID me set karo
            setSearchId(decodedText);

            // scanner band
            scannerRef.current.clear();
            scannerRef.current = null;
            setShowScanner(false);

            // auto search
            searchBooking(decodedText);
          },
          (error) => {
            console.error(error);
          }
        );
      }
    }, 300);
  };

  const stopScanner = async () => {
    if (scannerRef.current) {
      await scannerRef.current.clear();
      scannerRef.current = null;
    }

    setShowScanner(false);
  };

  const searchBooking = async (ticketId) => {
    setLoading(true);
    setResult(null);
    setAlert({ type: "", message: "" });

    try {
      // 🔹 Event Booking
      const eventRes = await axios.get(
        `${process.env.REACT_APP_API_URL}/eventbookingsbyticket/${ticketId}`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
          }
        }
      );

      const docs = eventRes.data?.data?.documents;

      if (docs && docs.length > 0) {
        const data = docs[0];

        setResult(data);
        setPaymentStatus(data.paymentStatus?.toString() || "");
        setHasCome(data.hasCome?.toString() || "");
        setTableName("eventbooking");
        setLoading(false);
        return;
      }
    } catch (err) {
      console.error("Event booking error:", err);
    }

    try {
      // 🔹 Course Booking
      const courseRes = await axios.get(
        `${process.env.REACT_APP_API_URL}/coursebookingsbyticket/${ticketId}`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
          }
        }
      );

      const docs = courseRes.data?.data?.documents;

      if (docs && docs.length > 0) {
        const data = docs[0];

        setResult(data);
        setPaymentStatus(data.paymentStatus?.toString() || "");
        setHasCome(data.hasCome?.toString() || "");
        setTableName("coursebooking");
        //setSearchId("");
        setLoading(false);
        return;
      }
    } catch (err) {
      const apierror = _.get(err, ['response', 'data', 'error', 'message'], "No booking found ❌");
      setAlert({ type: "error", message: apierror });
      setLoading(false);
    }
  };

  const handleSearch = async (e) => {
    e.preventDefault();

    const newErrors = validate();
    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    searchBooking(searchId);
  };

  // ✅ Update
  const handleUpdate = async () => {
    if (!result) return;

    // 🚫 BLOCK UPDATE IF ALREADY VISITED
    if (result.hasCome === true) {
      setAlert({ type: "error", message: "Already visited, update not allowed ❌" });
      return;
    }

    try {
      setLoading(true);
      await axios.put(
        `${process.env.REACT_APP_API_URL}/booking-confirmed`,
        {
          id: result.$id,
          tableName: tableName, // 🔥 send table name
          hasCome: hasCome === "true",
        },
        {
          headers: { Authorization: 'Bearer ' + token }
        }
      );

      setResult((prev) => ({
        ...prev,
        hasCome: true,
        visitedAt: new Date().toISOString()
      }));

      setHasCome("true");

      setAlert({ type: "success", message: "Updated Successfully ✅" });

      // Clear ticket field
      setSearchId("");

      // Refresh visited bookings immediately
      await getAllbookingWhoHasVisited();

      // Refresh again after 1 sec

      setTimeout(() => {
        getAllbookingWhoHasVisited();
      }, 1000);

    } catch (err) {
      const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Update failed ❌");
      setAlert({ type: "error", message: apierror });
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  const getAllbookingWhoHasVisited = async () => {
    try {
      setLoading(true);

      const res = await axios.get(`${process.env.REACT_APP_API_URL}/bookings-who-visited`, {
        params: {
          eventPage: currentEventPage,
          coursePage: currentPage,
          limit

        },
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token // Replace with your token
        }
      });

      const data = res.data?.data || [];
      if (Array.isArray(data.events) && data.events.length > 0) {
        const eventBookings = data.events;
        setEventBookings(eventBookings);

        //setCurrentEventPage(data.epagination.page);
        setTotalEventPages(data.epagination.totalPages);
        setTotalEventRecord(data.epagination.total);
      }

      if (Array.isArray(data.courses) && data.courses.length > 0) {
        const courseBookings = data.courses;
        setCourseBookings(courseBookings);

        //setCurrentPage(data.cpagination.page);
        setTotalPages(data.cpagination.totalPages);
        setTotalRecord(data.cpagination.total);
      }
    } catch (err) {
      const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Something went wrong");
      setAlert({ type: "error", message: apierror });
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };
  return (
    <section>
      <style>
        {`
.checkbox-field {
  margin-top: 12px;
}

.checkbox-field label {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

/* 🔥 Bigger checkbox */
.checkbox-field input[type="checkbox"] {
  width: 22px;
  height: 22px;
  cursor: pointer;
  accent-color: #22c55e; /* green */
}

/* Label text */
.label-text {
  font-size: 16px;
  font-weight: 600;
}
`}
      </style>
      <div className="is-title-bar">
        <div className="flex flex-col md:flex-row items-center justify-between space-y-6 md:space-y-0">
          <ul>
            <li><Link to="/dashboard" className='btn btn-primary'>Dashboard</Link></li>
            <li>Search Booking</li>
          </ul>
        </div>
      </div>

      <div className="section main-section">
        <div className="grid gap-6 grid-cols-1 md:grid-cols-12">
          <div className="card">
            <header className="card-header">
              <p className="card-header-title">
                <span className="icon"><i className="mdi mdi-reorder-horizontal"></i></span>
                Search Booking
              </p>
            </header>

            {loading ? (
              <div className="flex justify-center items-center py-10">
                <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500 border-solid"></div>
              </div>

            ) : (
              <>
                <div className="card-content">

                  {alert.message && (
                    <AlertMessage
                      type={alert.type}
                      message={alert.message}
                      onClose={() => setAlert({ type: "", message: "" })}
                    />
                  )}

                  {/* ================= SEARCH + SCANNER UI ================= */}
                  <div className="grid gap-6 grid-cols-1 md:grid-cols-12">
                    <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">
                      <div className="flex-1">
                        <div className="grid gap-6 grid-cols-1 md:grid-cols-12 mb-3">
                          <div className="field flex-1 w-full">
                            <label className="label">
                              Ticket ID <span style={{ color: "red" }}>*</span>
                            </label>

                            <div className="control">
                              <input
                                className="input"
                                type="text"
                                placeholder="Enter Ticket ID"
                                value={searchId}
                                onChange={(e) => setSearchId(e.target.value)}
                              />
                            </div>

                            {errors.ticket_id && (
                              <p className="help" style={{ color: "red" }}>
                                {errors.ticket_id}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="grid gap-6 grid-cols-1 md:grid-cols-12">
                          {/* Search Button */}
                          <div className="flex justify-center items-center">
                            <div className="field sm:mb-3">
                              <button
                                onClick={handleSearch}
                                className="button green"
                                style={{
                                  height: "42px",
                                  minWidth: "120px"
                                }}
                              >
                                {loading ? "Searching..." : "Search"}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="flex-1">
                        <div className="grid gap-0 grid-cols-1 md:grid-cols-12 mb-3">
                          <div className="label">
                            &nbsp;
                          </div>
                          {!showScanner ? (
                            <div className="flex justify-center items-center">
                              <div className="field sm:mb-3">
                                <button
                                  type="button"
                                  onClick={startScanner}
                                  className="button blue"
                                  style={{
                                    height: "42px",
                                    minWidth: "150px",
                                    fontWeight: "600"
                                  }}>
                                  Scan QR
                                </button>
                              </div>
                            </div>
                          ) : (
                            <div
                              className="p-4 border rounded-lg shadow bg-white flex flex-col items-center"
                              style={{
                                width: "100%",
                                maxWidth: "350px"
                              }}
                            >
                              <div
                                id="reader"
                                style={{
                                  width: "100%",
                                }}
                              ></div>

                              <button
                                className="button red mt-4"
                                onClick={stopScanner}
                                style={{
                                  width: "100%",
                                  fontWeight: "600"
                                }}
                              >
                                Close Scanner
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {result && (
                    <div className="mt-6 flex flex-col md:flex-row gap-6 mt-6">

                      {/* LEFT */}
                      <div className="w-full md:w-1/2">
                        <h3 className="mb-2"><b>{tableName === "eventbooking"
                          ? "Event Booking Found"
                          : tableName === "coursebooking"
                            ? "Course Booking Found"
                            : "Booking Found"}</b></h3>
                        <table>
                          <tbody>
                            <tr>
                              <th>Ticket ID</th>
                              <td>{result.ticketID}</td>
                            </tr>
                            <tr>
                              <th>User</th>
                              <td>{
                                allUsers.find(
                                  (user) => user.$id === result.users
                                )?.email || ""
                              }</td>
                            </tr>
                            <tr>
                              <th>{tableName === "coursebooking" ? "Course Name" : "Event Name"}</th>
                              <td>{tableName === "eventbooking" ?
                                allEvents.find(
                                  (event) => event.$id === result.events
                                )?.name || ""
                                : allCourses.find(
                                  (course) => course.$id === result.courses
                                )?.name || ""}</td>
                            </tr>
                            <tr>
                              <th>Payment Gateway</th>
                              <td>{result.paymentGateway || "-"}</td>
                            </tr>
                            <tr>
                              <th>Payment Status</th>
                              <td>{result.paymentStatus ? "Paid" : "Pending"}</td>
                            </tr>
                            <tr>
                              <th>Visited</th>
                              <td>{result.hasCome ? "Yes" : "No"}</td>
                            </tr>
                            <tr>
                              <th>Visited At</th>
                              <td>{result.visitedAt
                                ? new Date(result.visitedAt).toLocaleString()
                                : "-"}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      {/* RIGHT */}
                      <div className="w-full md:w-1/2">
                        {!result.hasCome && (
                          <div className="mt-4">
                            <div className="field checkbox-field">
                              <label>
                                <input
                                  type="checkbox"
                                  checked={hasCome === "true"}
                                  onChange={(e) =>
                                    setHasCome(e.target.checked ? "true" : "false")
                                  }
                                />
                                <span className="label-text">Has Come</span>
                              </label>
                            </div>
                            <button
                              onClick={handleUpdate}
                              className="button green mt-3"
                              disabled={hasCome !== "true"}
                              style={{
                                opacity: hasCome === "true" ? 1 : 0.5,
                                cursor: hasCome === "true" ? "pointer" : "not-allowed"
                              }}
                            >
                              Update Booking
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* ================= VISITED BOOKINGS ================= */}

                  <div className="mt-6">

                    {/* EVENT BOOKINGS */}
                    <div className="mb-6">
                      <h3 className="mb-2"><b>Visited Event Bookings</b></h3>

                      <table className="table-auto w-full border">
                        <thead>
                          <tr>
                            <th>Ticket ID</th>
                            <th>Event</th>
                            <th>User</th>
                            <th>Payment</th>
                            <th>Visited At</th>
                          </tr>
                        </thead>

                        <tbody>
                          {eventBookings.length > 0 ? (
                            eventBookings.map((item, index) => (
                              <tr key={index}>
                                <td>{item.ticketID}</td>
                                <td>{
                                  allEvents.find(
                                    (event) => event.$id === item.events
                                  )?.name || ""
                                }</td>
                                <td>{
                                  allUsers.find(
                                    (user) => user.$id === item.users
                                  )?.email || ""
                                }</td>

                                <td>
                                  {item.paymentStatus ? "Paid" : "Pending"}
                                </td>

                                <td>
                                  {item.visitedAt
                                    ? new Date(item.visitedAt).toLocaleString()
                                    : "-"}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="3">No visited event bookings</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                      {totalEventPages > 1 && (
                        <div className="grid grid-cols-3 items-center gap-4 mt-5">

                          {/* LEFT */}
                          <div className="flex items-center gap-2">
                            <span className="text-sm">Go to :</span>

                            <select
                              className="input"
                              style={{ width: "70px" }}
                              value={currentEventPage}
                              onChange={(e) => setCurrentEventPage(Number(e.target.value))}
                            >
                              {Array.from({ length: totalEventPages }, (_, i) => (
                                <option
                                  key={i + 1}
                                  value={i + 1}
                                >
                                  {i + 1}
                                </option>
                              ))}
                            </select>
                          </div>

                          {/* CENTER */}
                          <div className="flex justify-center items-center gap-2">

                            <button
                              className="button"
                              disabled={currentEventPage === 1}
                              onClick={() => setCurrentEventPage(prev => prev - 1)}
                            >
                              Previous
                            </button>

                            {getPagination(currentEventPage, totalEventPages).map((page) => (
                              <button
                                key={page}
                                className={`button ${page === currentEventPage ? "blue" : ""}`}
                                onClick={() => setCurrentEventPage(page)}
                              >
                                {page}
                              </button>
                            ))}

                            <button
                              className="button"
                              disabled={currentEventPage === totalEventPages}
                              onClick={() => setCurrentEventPage(prev => prev + 1)}
                            >
                              Next
                            </button>

                          </div>

                          {/* RIGHT */}

                          <div className="text-right">
                            Page {currentEventPage} of {totalEventPages}
                          </div>

                        </div>
                      )}

                    </div>
                  </div>


                  {/* COURSE BOOKINGS */}
                  <div>
                    <h3 className="mb-2"><b>Visited Course Bookings</b></h3>

                    <table className="table-auto w-full border">
                      <thead>
                        <tr>
                          <th>Ticket ID</th>
                          <th>Course</th>
                          <th>User</th>
                          <th>Payment</th>
                          <th>Visited At</th>
                        </tr>
                      </thead>

                      <tbody>
                        {courseBookings.length > 0 ? (
                          courseBookings.map((item, index) => (
                            <tr key={index}>
                              <td>{item.ticketID}</td>
                              <td>{
                                allCourses.find(
                                  (course) => course.$id === item.courses
                                )?.name || ""
                              }</td>
                              <td>{
                                allUsers.find(
                                  (user) => user.$id === item.users
                                )?.email || ""
                              }</td>

                              <td>
                                {item.paymentStatus ? "Paid" : "Pending"}
                              </td>

                              <td>
                                {item.visitedAt
                                  ? new Date(item.visitedAt).toLocaleString()
                                  : "-"}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="3">No visited course bookings</td>
                          </tr>
                        )}
                      </tbody>
                    </table>



                    {totalPages > 1 && (
                      <div className="grid grid-cols-3 items-center gap-4 mt-5">

                        {/* LEFT */}
                        <div className="flex items-center gap-2">
                          <span className="text-sm">Go to :</span>

                          <select
                            className="input"
                            style={{ width: "70px" }}
                            value={currentPage}
                            onChange={(e) => setCurrentPage(Number(e.target.value))}
                          >
                            {Array.from({ length: totalPages }, (_, i) => (
                              <option
                                key={i + 1}
                                value={i + 1}
                              >
                                {i + 1}
                              </option>
                            ))}
                          </select>
                        </div>

                        {/* CENTER */}
                        <div className="flex justify-center items-center gap-2">

                          <button
                            className="button"
                            disabled={currentEventPage === 1}
                            onClick={() => setCurrentPage(prev => prev - 1)}
                          >
                            Previous
                          </button>

                          {getPagination(currentPage, totalPages).map((page) => (
                            <button
                              key={page}
                              className={`button ${page === currentPage ? "blue" : ""}`}
                              onClick={() => setCurrentPage(page)}
                            >
                              {page}
                            </button>
                          ))}

                          <button
                            className="button"
                            disabled={currentPage === totalPages}
                            onClick={() => setCurrentPage(prev => prev + 1)}
                          >
                            Next
                          </button>

                        </div>

                        {/* RIGHT */}

                        <div className="text-right">
                          Page {currentPage} of {totalPages}
                        </div>

                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>

        </div>
      </div>
    </section>
  );
}

export default Bookings;
